import React from 'react';
import PropTypes from 'prop-types';
import Highlighter from 'react-highlight-words';
import cn from 'classnames';

import { Button } from 'components/common/Elements/Elements';

import classes from './Comments.module.scss';

const ifFindSearhText = (data, searchText, highlighterTrgiger = []) => {
  let trigerOn = highlighterTrgiger.some(el =>
    data[el].toLowerCase().includes(searchText.toLowerCase())
  );
  return searchText && trigerOn;
};

const Comments = ({
  title,
  text,
  data,
  lengthShowZone = 100,
  onOpenAdditionalModal,
  showBtnMorealways,
  onlyNA,
  searchText,
  highlighterTrgiger,
  BodyModal
}) => {
  return (
    <div>
      {(onlyNA && text.length < 0) || text === 'NA'
        ? 'NA'
        : (text.length > lengthShowZone + 1 || showBtnMorealways) && (
            <>
              <Highlighter
                autoEscape
                highlightClassName={classes.highlight}
                searchWords={[searchText]}
                textToHighlight={text.substr(0, lengthShowZone)}
              />{' '}
              <Button
                className={cn(
                  classes.button,
                  ifFindSearhText(data, searchText, highlighterTrgiger) &&
                    classes.highlight
                )}
                onClick={() =>
                  onOpenAdditionalModal({
                    content: (
                      <BodyModal
                        data={data}
                        searchText={searchText}
                        title={title}
                      />
                    )
                  })
                }
              >
                more...
              </Button>
            </>
          )}
    </div>
  );
};

Comments.propTypes = {
  text: PropTypes.string,
  lengthShowZone: PropTypes.number,
  onOpenAdditionalModal: PropTypes.func,
  data: PropTypes.object,
  showBtnMorealways: PropTypes.bool,
  searchText: PropTypes.string,
  highlighterTrgiger: PropTypes.array,
  BodyModal: PropTypes.func,
  onlyNA: PropTypes.bool,
  title: PropTypes.string
};

export default Comments;
